export interface PrismaAutomationSSEEvent {
  created_at: Date;
  id: string;
  stageAutomation: {
    is_sync: boolean;
    name: string;
  };
  stageAutomationExecutionAction: {
    created_at: Date;
    id: string;
    last_heartbeat_at: Date;
    stageAutomationExecutionActionLogs: {
      created_at: Date;
      id: string;
      message: string;
      status: string;
    }[];
    status: string;
    type: string;
  }[];
  status: string;
}

export interface AutomationSSEEventAutomation {
  actions: {
    createdAt: string;
    id: string;
    lastHeartbeatAt: string | null;
    logs: {
      createdAt: string;
      id: string;
      message: string;
      status: string;
    }[];
    status: string;
    type: string;
  }[];
  automation: {
    isSync: boolean;
    name: string;
  };
  createdAt: string;
  id: string;
  status: string;
}

export class AutomationSSEEvent {
  public records: AutomationSSEEventAutomation[] = [];

  private constructor(data: AutomationSSEEventAutomation[]) {
    this.records = data;
  }

  public static fromPrisma(data: PrismaAutomationSSEEvent[]): AutomationSSEEvent {
    const records = data.map((item) => ({
      id: item.id,
      status: item.status,
      createdAt: item.created_at.toISOString(),
      automation: {
        name: item.stageAutomation.name,
        isSync: item.stageAutomation.is_sync,
      },
      actions: item.stageAutomationExecutionAction.map((action) => ({
        id: action.id,
        lastHeartbeatAt: action.last_heartbeat_at ? action.last_heartbeat_at.toISOString() : null,
        status: action.status,
        type: action.type,
        createdAt: action.created_at.toISOString(),
        logs: action.stageAutomationExecutionActionLogs.map((log) => ({
          id: log.id,
          status: log.status,
          message: log.message,
          createdAt: log.created_at.toISOString(),
        })),
      })),
    }));

    return new AutomationSSEEvent(records);
  }
}
